// *************************
//  Selectors

const navToggle = document.querySelector('#nav-toggle');

// *************************
//  Functions

const toggleHasOverlayOnBody = function () {
  if (navToggle.checked) {
    document.body.classList.add('has-overlay');
  } else {
    document.body.classList.remove('has-overlay');
  }
};

// *************************
//  Event Listeners

navToggle.addEventListener('change', toggleHasOverlayOnBody);
